// extracted by mini-css-extract-plugin
module.exports = {"bookingBtnTheme1":"BookingPanel_bookingBtnTheme1__1Qrnx","bookingBtnTheme2":"BookingPanel_bookingBtnTheme2__3ZcAf"};